var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":""}},_vm._l((_vm.computedOptions),function(option,index){return _c('v-flex',{key:`option-${index}`},[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_vm._v(" "+_vm._s(option.checkPoint.point)+" ")])],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }